import React, {Fragment, useEffect, useReducer, useState} from 'react';
import PropTypes from "prop-types";

var bootbox = require('bootbox');

import ModalContentWrapper from '../ModalContentWrapper';
import useAutoForm from "../../Forms/useAutoForm";

import DemoModal from "root/DemoModal";
import {getFamilyDetails, saveNewFamily, updateFamily, deleteFamily} from "root/DataFunctions/FamilyDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getChildImageUrl} from "root/DataFunctions/ChildDataFns";
import {ImageType} from "root/DataFunctions/Constants";

const ModalAddFamily2 = (props) =>
{
    const [ ,forceRender] = useReducer((s) => s+1, 0)
    const [ initialiseForm, renderForm, isFormValid, getFormData, setDisplayErrors, isInitialised] = useAutoForm( forceRender ) ;
    const [ buttonState, setButtonState ] = useState ('') ;

    const [data, setData] = useState({ isLoading: true, data: [] });

    const [newImageData, setNewImageData] = useState( null );
    const [imageDataAlias, setImageDataAlias] = useState( null );

    const isFetchRequired = props.mode === 'edit' || props.mode === 'view' || props.mode === 'delete' ;

    const titles = {
        view: 'View Family Details',
        edit: 'Edit Family Details',
        create: 'New Family',
        delete: 'Delete Family'
    } ;

    const saveButtonText = {
        view: 'Close',
        edit: 'Save Changes',
        create: 'Save',
        delete: 'Click To Delete'
    } ;

    const getDefaultData = () =>
    {
        return {
            family_name: '',
            family_type: '',
        }
    }

    const initForm = ( data, mode ) =>
    {
        const items = [
            {
                ref: 'InputFamilyName',
                autoFocus: true,
                tabIndex: 1,
                item_name: 'family_name',
                default: null,
                label: 'Family Name',
                errorText: 'You must enter a family name',
                field_type: 'input',
                data_type: 'string',
                validation: {required: true},
                colSpan: 12,
                lineBreak: false,
                value: data.family_name
            },
            {
                ref: 'InputFamilyType',
                tabIndex: 2,
                item_name: 'family_type',
                default: null,
                label: 'Family Type',
                errorText: 'You must select a Family Type',
                field_type: 'dropdown_familytype',
                data_type: 'string',
                controlled: true,
                validation: {required: true },
                colSpan: 12,
                lineBreak: false,
                value: data.type_id
            },
        ];

        initialiseForm( items, mode );
    }

    useEffect(() =>
    {
        if ( isFetchRequired )
        {
            getFamilyDetails(props.child_id, props.family_id, (response) =>
            {
                let familyData = getDataFromResponse(response)[0] ;

                setData({ isLoading: false, data: familyData });
                setImageDataAlias(familyData.image_id);
            });
        }
        else
        {
            if ( props.mode === 'create')
            {
                setData({ isLoading: false, data: getDefaultData() });
            }
        }

    }, [props.family_id]);

    useEffect(() =>
    {
        // This triggers after the data is loaded and isLoading toggles to false
        // At this point we know the data is ready to be rendered

        if ( data.isLoading === false )
        {
            initForm( data.data, props.mode ) ;
        }
    }, [data.isLoading]);

    const onSaveComplete = () =>
    {
        props.onSaveCompleted ('saved');
        props.onClose() ;
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const appendImageToForm = ( formData ) =>
    {
        if ( newImageData !== null )
        {
            // Create a data type to send the image to the server
            const ownerFormItem = {
                ref: 'InputImage',
                field_type: 'image',
                data_type: 'blob',
                item_name: 'image',
                value: newImageData
            } ;

            const ndata =  [ownerFormItem, ...formData] ;

            return ndata ;
        }
        else
        {
            return formData ;
        }
    }

    const doSaveNew = ( callback ) =>
    {
        if ( !isFormValid())
        {
            setDisplayErrors( true ) ;
            setButtonState ( '' ) ;
        }
        else
        {
            const data = appendImageToForm( getFormData() ) ;
            saveNewFamily (props.child_id, data, onSaveComplete ) ;
        }
    }

    const doSave = (callback) =>
    {
        if ( !isFormValid())
        {
            setDisplayErrors( true ) ;
            setButtonState ( '' ) ;
        }
        else
        {
            const data = appendImageToForm( getFormData() ) ;
            updateFamily (props.child_id, props.family_id, data, onSaveComplete ) ;
        }
    }

    const doDelete = ( onComplete ) =>
    {
        deleteFamily( props.child_id, props.family_id, onSaveComplete ) ;
    }

    const onClickSave = () =>
    {
        disableButtons();

        switch (props.mode)
        {
            case 'create' :
                doSaveNew(onSaveComplete);
                break;
            case 'edit' :
                doSave(onSaveComplete);
                break;
            case 'delete' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to delete this Family?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doDelete();
                        }
                    })
                })
                break;
        }
    }

    const disableButtons = () =>
    {
        setButtonState ('disabled');
    }

    const enableButtons = () =>
    {
        setButtonState ('') ;
    }

    const Title = ( props ) =>
    {
        return <h3>{titles[props.mode]}</h3>
    }

    const onImageChange = ( imageUrl ) =>
    {
        const reader = new window.FileReader();
        reader.readAsDataURL(imageUrl);

        reader.onloadend = () =>
        {
            setNewImageData ( reader.result ) ;
            setImageDataAlias ( reader.result ) ;
        }
    }

    const isReadOnly = props.mode === 'view' || props.mode === 'delete' ;

    const getSaveButtonText = ( mode ) =>
    {
        return saveButtonText[props.mode] ;
    }

    const getSaveButtonStyle= ( mode ) =>
    {
        switch ( mode )
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small" ;
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small" ;
        }
    }

    const SaveButton = (props) =>
    {
        const clickHandler = buttonState === '' ? onClickSave : null;

        return (
            <button onClick={clickHandler} style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className={getSaveButtonStyle(props.mode)}>{getSaveButtonText(props.mode)}<i className="et-save" /></button>
        )
    }

    const handleRemoveImage = () => {
        setNewImageData("");
        setImageDataAlias(null);
    }

    const formContent = () =>
    {
        if ( data.isLoading === true )
        {
            return (
                <div style={{width: props.width}}>
                    <SpinnerDiv />
                </div>
            )
        }
        else
        {
            return (
                <Fragment>
                    <div className="profile-img-container-wrap profile-img-container-wrap_child">
                            {!isReadOnly &&  
                                <div className="post-all-image-wrap">
                                    <div
                                        className={imageDataAlias === null ?
                                                    "post-all-image"
                                                    :
                                                    "post-all-image post-all-image_show"
                                                }
                                    >
                                        <DemoModal 
                                        image_id={data.data.image_id} 
                                        image_type={ImageType.IMAGE_FAMILY} 
                                        provider_id={1} 
                                        dimensions={150} 
                                        onImageChange={onImageChange}
                                        newImageData={newImageData}
                                        imageDataAlias={imageDataAlias}
                                        data={data}
                                        />
                                        <span onClick={handleRemoveImage} className="post-image-remove">
                                            <i className='icon-close'/>
                                        </span>
                                        <div className="post-all-image-overlay post-all-image-overlay_single"></div>
                                    </div>
                                </div>
                            }
                        
                        {isReadOnly && <img src={getChildImageUrl(data.data.image_id, data.data.user_id)} style={{width: '150px'}} />}
                    </div>

                    <div style={{width: props.width}}>
                        {isInitialised && renderForm( { readonly: isReadOnly })}
                    </div>

                    <div className="d-flex flex-row justify-content-end">
                        <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left" /></button>
                        <SaveButton mode={props.mode} onClick={onClickSave} />
                    </div>
                </Fragment>
            )
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode} />

            {formContent()}

        </ModalContentWrapper>
        )
}

export default ModalAddFamily2;

ModalAddFamily2.defaultProps =
{
    width: '400px',
    height:'600px'
}

ModalAddFamily2.propTypes = {
    child_id: PropTypes.string.isRequired,
    family_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
